
// Tipos de autenticación
export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS";
export const SIGNOUT_SUCCESS = "SIGNOUT_SUCCESS";
export const AUTH_ERROR_READ = "AUTH_ERROR_READ";
export const AUTH_ERROR = "AUTH_ERROR";
